import { ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { finalize, map, takeUntil, tap } from 'rxjs/operators';

import { CustomResultOfPaginatedListOfNumberInformationWithPagination } from 'src/app/core/api/models';
import { EventTypes } from 'src/app/core/constants/event-types';
import {
  Bulk2ServicesService,
  BulkServicesService,
} from '../../../core/api/services';
import { BulkNumberInformationComponent } from '../bulk-number-information/bulk-number-information.component';
import { PageNames } from 'src/app/configs/page-names.enum';
import { BaseIndexModule } from '../../shared/base/modules/base-index.module';
import { BulkNumberInformation2FormComponent } from "./bulk-number-information2-form/bulk-number-information2-form.component";
import { SimTypeDirective } from '../bulk-number-information/shared/sim-type.directive';
import { BulkNumbersDeleteFromXlsx2Component } from "./bulk-number-delete-from-xlsx2/bulk-numbers-delete-from-xlsx2.component";


@Component({
    selector: 'app-bulk-number-information2',
    templateUrl: './bulk-number-information2.component.html',
    styleUrls: ['./bulk-number-information2.component.scss'],
    imports: [BaseIndexModule, BulkNumberInformation2FormComponent, SimTypeDirective, BulkNumbersDeleteFromXlsx2Component]
})
export class BulkNumberInformation2Component
  extends BulkNumberInformationComponent
  implements OnInit
{
  //#region Properties

  pageName = PageNames.bulkNumberInformation;

  protected currentService = inject(BulkServicesService);

  isShowCancelToken: boolean = false;

  //#endregion

  constructor(
    public current2Service: Bulk2ServicesService,
    public cd: ChangeDetectorRef
  ) {
    super(cd);
  }

  ngOnInit() {
    try {
      super.ngOnInit();
      this.pageConfig.title = this.pageVocabs + 'title2';
      this.setPageService(
        this.current2Service,
        'bulk2ServicesCreateSingleNumberInformationGet'
      );
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  getItems() {
    try {
      if (this.items) this.isShowCancelToken = true;
      if (
        !this.lastSelectedItemId ||
        this.lastSelectedItemId.length == this.paginationModel.pageSize
      ) {
        //مدلی که در ویو ساب اسکرایب میشه
        this.subs = this.getPaginationApi()
          .pipe(
            tap((item) => {
              this.getPaginationData(item);
            }),
            map((item) => item?.data?.items),
            tap((items) => {
              this.items = items;
              items?.length > 0
                ? (this.pageConfig.isEmpty = false)
                : (this.pageConfig.isEmpty = true);
            }),
            takeUntil(this.onDestroy$),
            finalize(() => {
              const timeOut = setTimeout(() => {
                this.pageConfig.loading = false;
                clearTimeout(timeOut);
              }, 200);
            })
          )
          .subscribe();
      } else {
        this.items$ = of(this.items);
        this.lastSelectedItemId = null;
        this.pageConfig.loading = false;
      }
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.baseIndexPage
      );
    }
  }

  getConfirmClose(event) {
    if (event) this.subs.unsubscribe();

    this.isShowCancelToken = false;
  }

  //#region Api

  //Get All
  getPaginationApi(): Observable<CustomResultOfPaginatedListOfNumberInformationWithPagination> {
    return this.current2Service.bulk2ServicesGetBulkNumberInformationWithPagination(
      { body: { ...this.getBaseModelWithPaginationParams() } }
    );
  }
}
